angular.module('jv.Dashboard.ReportBookmark.Controller', [])
.controller('jv.Dashboard.ReportBookmark.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs','$rootScope', 'TemplateLoader','$sce','$filter',
    
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, TemplateLoader,$sce, $filter){
        $scope.refreshTimestamp = true;
        //Handler for refresh_widget
        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                $scope.refreshTimestamp = false;
                $scope.fetchBookmarks(0);
            }
        });

        $scope.pageSize = 5;
        $scope.totalCount = 0;
        $scope.currentPage = 0;
        $scope.bookmarks = '';
        $scope.reportPageUrl = $window.jvUrls.analytics + '/reports/list.html#/';
        
        $scope.fetchBookmarks = function(pageNumber){
            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            $scope.currentPage = pageNumber;
            var todaysDate = $rootScope.fetchTodayInUsersTimeZone();
            var postData = {
                'page': pageNumber,
                'pageSize': 5
            };
            jvDashboardAjaxService.getReportBookmarks(postData,function(response){
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.refreshTimestamp = true;
                $scope.totalCount = response.totalCount;
                if(response){
                    $scope.bookmarks = response.bookmarks;
                    if (response.bookmarks) {
                        angular.forEach($scope.bookmarks,function(bookmark,key){
                            var bookmarkUrl =  $window.jvUrls.analytics + '/bookmarks/go/' + bookmark.reportEId + '/' + bookmark.param;
                            bookmark.runUrl = bookmarkUrl;
                            jvDashboardAjaxService.getReportDetails({'reportEId': bookmark.reportEId}, function(reportDetail){
                            	var fileName = "";
                            	if(reportDetail.file && reportDetail.file.name){
                            		fileName = reportDetail.file.name;
                            		if (fileName.lastIndexOf("()()()") > 0) {
                            			fileName = fileName.substring(0, fileName.lastIndexOf("()()()"));
                            		}
                            	}
                            	bookmark.reportName = fileName;
                            });
                        });
                    }
                } else {
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        };
        
        $scope.fetchBookmarks(0);
}]);